import { render, staticRenderFns } from "./BModalFilterBar.vue?vue&type=template&id=5c5b8070"
import script from "./BModalFilterBar.vue?vue&type=script&lang=js"
export * from "./BModalFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports